import React from "react";
export const Money = (props) => {
    return (React.createElement("span", { className: props.cssWrapper }, MoneyStr(props.amount, props.decimals)));
    //en: <span className={props.cssWrapper}>&pound;{ isNegative && "-"}{value.toLocaleString('en', { minimumFractionDigits: decimals })}</span>
};
export const MoneyStr = (amount, decimals) => {
    let isNegative = amount < 0 ? true : false;
    let value = Math.abs(amount);
    return (isNegative ? "-" : "") + value.toLocaleString('cs', { minimumFractionDigits: decimals || 0 }) + ' Kč';
};
